import type { FC } from 'react';
import { SubscriptionInoTab } from '@/Module/Subscription/Component';
const SubscriptionListEmpty: FC = () => {
  return <div className="my-auto flex h-full flex-col items-center justify-center" data-sentry-component="SubscriptionListEmpty" data-sentry-source-file="SubscriptionListEmpty.tsx">
      <div className="mb-2 text-center text-lg font-bold">هنوز اشتراکی فعال ندارید!</div>
      <div className="mb-4  text-center text-lg md:mb-8">
        همین حالا اشتراک خود را فعال کنید و از تجربه‌ی کامل یادگیری بهره‌مند شوید.
      </div>
      <div className="w-full">
        <SubscriptionInoTab data-sentry-element="SubscriptionInoTab" data-sentry-source-file="SubscriptionListEmpty.tsx" />
      </div>
    </div>;
};
export default SubscriptionListEmpty;